export const TermsLoadError = ({
  onRetry,
  onGround = false,
}: {
  onRetry: () => void;
  // Straight on the page background rather than on a card.
  onGround?: boolean;
}) => (
  <p
    className={
      onGround ? 'text-sm text-ground-error' : 'text-sm text-error-600'
    }
  >
    We couldn&apos;t load the terms.{' '}
    <button
      type="button"
      className="underline underline-offset-4"
      onClick={onRetry}
    >
      Try again
    </button>
  </p>
);
